module.exports = __webpack_public_path__ + "static/media/yes.9cd0a8bb.png";